// @flow

import * as React from 'react';
import { editStaffVenueRelevanceScoresPath } from 'routes';
import FAIcon from 'common/components/FAIcon';
import styles from './EditRelevanceLink.scss';

export const editRelevanceLinkWrapperClass = styles.wrapper;

type Props = { venueId: number, ... };

function EditRelevanceLink(props: Props) {
  return (
    <a
      href={editStaffVenueRelevanceScoresPath({ venue_id: props.venueId })}
      className={styles.link}
      title="Edit relevance scores for this venue"
    >
      <FAIcon name="sliders" />
    </a>
  );
}

export default EditRelevanceLink;
